import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
    const { authed } = useAuth();
    const loc = useLocation();

    if (authed === null) {
        return (
            <div
                className="min-h-screen bg-[#090a0b] flex items-center justify-center font-mono text-[11px] text-[#9ca3af]"
                data-testid="auth-checking"
            >
                checking session…
            </div>
        );
    }
    if (authed === false) {
        return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
    }
    return children;
}
